import { Component, OnInit, OnDestroy } from '@angular/core';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { NavigationError, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'telio-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Evcharging';
  mediaSub = new Subscription();
  deviceXs: boolean;

  constructor(public mediaObserver: MediaObserver, readonly translate: TranslateService,
   readonly router: Router) {
    this.translate.setDefaultLang('en');
    const lang = localStorage.getItem('lang') || 'en';
    this.translate.use(lang);
    document.documentElement.lang = lang;

    router.events.subscribe(event => {
      event instanceof NavigationError ? window.location.reload() : null;
    });
  }

  ngOnInit() {
    this.mediaSub.add(this.mediaObserver.media$.subscribe((res: MediaChange) => {
      this.deviceXs = res.mqAlias === "xs" ? true : false;
    }))
  }

  ngOnDestroy() {
    this.mediaSub && this.mediaSub.unsubscribe();
  }
}
